import { render } from "./CxSosPopup.vue?vue&type=template&id=062ec8e1"
import script from "./CxSosPopup.vue?vue&type=script&lang=js"
export * from "./CxSosPopup.vue?vue&type=script&lang=js"

import "./CxSosPopup.vue?vue&type=style&index=0&id=062ec8e1&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__